
      if (import.meta.env.VITE_TINYMCE_API_KEY) {
        const tinyScript = document.createElement('script');
        tinyScript.src = `https://cdn.tiny.cloud/1/${import.meta.env.VITE_TINYMCE_API_KEY}/tinymce/6/tinymce.min.js`;
        tinyScript.referrerPolicy = 'origin';
        document.head.appendChild(tinyScript);
      }
    